import { Button, Form, Input } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import PropTypes from 'prop-types';
import { useState } from 'react';
import RevealEyeButton from '../../../../components/RevealEyeButton';

function ChilexpressForm({ loading, name, onFinish, courierCredentials }) {
  const [form] = useForm();
  const [showSecret, setShowSecret] = useState(false);
  console.log(courierCredentials);
  return (
    <Form
      form={form}
      name={`${name}-form`}
      layout="vertical"
      labelCol={{
        span: 8,
        offset: 0,
      }}
      wrapperCol={{
        span: 20,
        offset: 0,
      }}
      initialValues={{
        remember: true,
        fbm: true,
        fbo: false,
      }}
      onFinish={onFinish}
      autoComplete="off"
      style={{
        marginBottom: 20,
      }}
    >
      <h1
        style={{
          fontWeight: 600,
          marginBottom: 40,
          marginTop: 15,
        }}
      >
        Conectar cuenta {name}
      </h1>

      <span
        style={{
          paddingLeft: 25,
          maxWidth: '100%',
          textAlign: 'left',
          fontSize: '18px',
          marginBottom: 30,
        }}
      >
        Client ID
      </span>
      <Form.Item
        name="clientId"
        rules={[
          {
            required: true,
            message: `Ingrese su client id de ${name}`,
          },
        ]}
        wrapperCol={{
          span: 24,
        }}
        style={{
          fontSize: '18px',
          maxWidth: '100%',
          paddingLeft: 25,
          paddingRight: 25,
        }}
      >
        <Input
          defaultValue=""
          autoComplete="off"
          type="text"
          onChange={(e) => form.setFieldValue('clientId', e.target.value)}
          size="large"
          style={{ borderRadius: 10, marginTop: 6 }}
        />
      </Form.Item>

      <span
        style={{
          paddingLeft: 25,
          maxWidth: '100%',
          textAlign: 'left',
          fontSize: '18px',
          marginBottom: 30,
        }}
      >
        Api Key
      </span>

      <Form.Item
        name="apiKey"
        rules={[
          {
            required: true,
            message: `Ingrese su api key de ${name}`,
          },
        ]}
        wrapperCol={{
          span: 24,
        }}
        style={{
          fontSize: '18px',
          maxWidth: '100%',
          paddingLeft: 25,
          paddingRight: 25,
        }}
      >
        <Input
          defaultValue=""
          autoComplete="new-password"
          type={showSecret ? 'text' : 'password'}
          onChange={(e) => form.setFieldValue('apiKey', e.target.value)}
          size="large"
          style={{ borderRadius: 10, marginTop: 6 }}
        />
        <div style={{ position: 'absolute', right: '-35px', top: '24%' }}>
          <RevealEyeButton
            onClick={() => setShowSecret(!showSecret)}
            show={showSecret}
          />
        </div>
      </Form.Item>

      <Form.Item
        wrapperCol={{
          span: 24,
        }}
        style={{
          marginTop: 35,
          textAlign: 'center',
        }}
      >
        <Button
          type="primary"
          htmlType="submit"
          loading={loading}
          style={{
            height: '50px',
            width: '30%',
          }}
        >
          {courierCredentials ? 'Actualizar' : 'Conectar'}
        </Button>
      </Form.Item>
    </Form>
  );
}

export default ChilexpressForm;

ChilexpressForm.propTypes = {
  loading: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  onFinish: PropTypes.func.isRequired,
  courierCredentials: PropTypes.instanceOf(Object).isRequired,
};
